__turbopack_context__.v({
  "line": "Burger-module__GZ4aPq__line",
  "line1": "Burger-module__GZ4aPq__line1",
  "line2": "Burger-module__GZ4aPq__line2",
  "line3": "Burger-module__GZ4aPq__line3",
  "menu": "Burger-module__GZ4aPq__menu",
  "opened": "Burger-module__GZ4aPq__opened",
});
